<template>
  <div class="main pd10">
    <div class="setting flex-row jc-start mb10">
      <el-button :icon="settingType ? 'el-icon-edit' : 'el-icon-view'" size="medium" :type="settingType ? 'warning' :''"  @click="handSetting">{{ settingType ? '编辑' : '确定' }} </el-button>
    </div>
    <!-- <div class="tabs">	
      <el-tabs v-model="activeName">
        <el-tab-pane label="English" name="en"></el-tab-pane>
        <el-tab-pane label="中文" name="cn"></el-tab-pane>
      </el-tabs>
    </div> -->
    <div class="homeLayout mg8">
      <el-row :gutter="15">
      <!-- 首屏内容 -->
      <div class="layout_bg bordersolid">
        <!-- <image-upload-new v-model="firstScreenImage.pic" :disabled="settingType" :limit="1" tip="单个图片不要超过10M" class="mb8" @updateChange="changeImage($event,firstScreenImage)"></image-upload-new> -->
        <el-col :span="24">
          <CropperView :imgSrc="firstScreenImage.pic" :disabled="settingType"  :actionButtonFlag="true" :objectFit="'cover'" :listIndex="1" :maxVideoSize="uploadVideoSize" @updateChange="changeImage($event,firstScreenImage)"></CropperView>
        </el-col>
        <div class="w100 flex-row flex-w">
          <el-col :span="11">
            <el-input  v-model="firstScreenTitle.valEn" :disabled="settingType" class="mt8" @change="changeInput($event,firstScreenTitle)"></el-input>
          </el-col>
          <el-col :span="11">
            <el-input  v-model="firstScreenTitle.valCn" :disabled="settingType" class="mt8" @change="changeInput($event,firstScreenTitle)"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="flex-row ai-end jc-start iconBox">
              <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(firstScreenTitle)"></i>
            </div>
          </el-col>
          <el-col :span="11">
            <el-input v-model="firstScreenContent.valEn" :disabled="settingType"  class="mt8 mb8" @change="changeInput($event,firstScreenContent)"></el-input>
          </el-col>
          <el-col :span="11">
            <el-input v-model="firstScreenContent.valCn" :disabled="settingType"  class="mt8 mb8" @change="changeInput($event,firstScreenContent)"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="flex-row ai-end jc-start iconBox" >
              <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(firstScreenContent)"></i>
            </div>
          </el-col>
        </div>
      </div>
      <!-- 关于我们 -->
      <div class="layout_aboutUs bordersolid mt4">
        <div class="flex-row jc-center mt8">
          <div class="w100">
            <el-col :span="11">
              <el-input v-model="aboutUsTitle.valEn"  :disabled="settingType" class="mt8" @change="changeInput($event,aboutUsTitle)"></el-input>
            </el-col>
            <el-col :span="11">
              <el-input v-model="aboutUsTitle.valCn"  :disabled="settingType" class="mt8" @change="changeInput($event,aboutUsTitle)"></el-input>
            </el-col>
            <el-col :span="2">
              <div class="flex-row ai-end jc-start iconBox">
                <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(aboutUsTitle)"></i>
              </div>
            </el-col>
            <el-col :span="11">
              <el-input type="textarea" rows="5" v-model="aboutUsContent.valEn"  :disabled="settingType" class="mt8" @change="changeInput($event,aboutUsContent)"></el-input>
            </el-col>
            <el-col :span="11">
              <el-input type="textarea" rows="5" v-model="aboutUsContent.valCn"  :disabled="settingType" class="mt8" @change="changeInput($event,aboutUsContent)"></el-input>
            </el-col>
            <el-col :span="2">
            <div class="flex-row ai-end jc-start iconBox" style="height: 115px;">
              <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(aboutUsContent)"></i>
            </div>
          </el-col>
          </div>
        </div>
        <div class="flex-row jc-evenly mt8 mb8">
          <el-col :span="8" v-for="(item,index) in aboutUsList" :key="index">
            <div class="flex-row">
              <div style="text-align: center;width:95%;">
                <el-input v-model="item.valNum"  :disabled="settingType" class="mt8" @change="changeInput($event,item)"></el-input>            
                <el-input v-model="item.valEn"  :disabled="settingType" class="mt8" @change="changeInput($event,item)"></el-input>
                <el-input v-model="item.valCn"  :disabled="settingType" class="mt8" @change="changeInput($event,item)"></el-input>
              </div>
              <div style="width:5%;">
                <div class="flex-row ai-end jc-start iconBox" style="height: 140px;margin-left:10px">
                  <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(item)"></i>
                </div>
              </div>
            </div>
        </el-col>
        </div>
        <div class="flex-row fw-warp mb8">
          <el-col :span="12" v-for="bitem in aboutUsBasicsList" :key="bitem.id">
            <div class="flex-row">
              <div class=" w100 mt8" style="width: 95%;">
                <div v-for="bcitem in bitem" :key="bcitem.id">
                  <image-upload-new v-if="bcitem.type == 'Image'" v-model="bcitem.pic" :disabled="settingType" :limit="1" tip="单个图片不要超过10M" class="mb8" @updateChange="changeImage($event,bcitem)"></image-upload-new>
                  <div v-if="bcitem.type == 'Title'" class="flex-row">
                    <el-input  v-model="bcitem.valEn"  :disabled="settingType" class="" @change="changeInput($event,bcitem)"></el-input>
                    <el-input  v-model="bcitem.valCn"  :disabled="settingType" class="ml8" @change="changeInput($event,bcitem)"></el-input>
                  </div>
                  <div v-if="bcitem.type == 'Tip'" class="flex-row mt8">
                    <el-input v-model="bcitem.valEn"  :disabled="settingType" class="" @change="changeInput($event,bcitem)"></el-input>
                    <el-input v-model="bcitem.valCn"  :disabled="settingType" class="ml8" @change="changeInput($event,bcitem)"></el-input>
                  </div>
                </div>
              </div>
              <div style="width: 5%;" class="flex-row ai-end jc-start">
                <div class="flex-row ai-center jc-center iconBox" >
                  <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(bitem)"></i>
                </div>
              </div>
            </div>
          </el-col>
        </div>
      </div>
      <!-- 我们的项目 -->
      <div class="ourProject bordersolid mt4">
        <div class="flex-row ai-center jc-center mt8">
          <div class="w100">
            <el-col :span="11">
              <el-input v-model="ourProjectTitle.valEn"  :disabled="settingType" class="" @change="changeInput($event,ourProjectTitle)"></el-input>
            </el-col>
            <el-col :span="11">
              <el-input v-model="ourProjectTitle.valCn"  :disabled="settingType" class="" @change="changeInput($event,ourProjectTitle)"></el-input>
            </el-col>
            <el-col :span="2">
              <div class="flex-row ai-end jc-start iconBox" style="height: 35px;">
                <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(ourProjectTitle)"></i>
              </div>
            </el-col>
          </div>
        </div>
        <div class="flex-row jc-center mt16">
          <div class="pd16">产品图册展示,请前往产品图册配置图册,选择是否在首页显示为是</div>
          <!-- <div class=" mt4">
            <image-upload-new v-model="inputForm.pic" :disabled="settingType" :limit="1" tip="单个图片不要超过10M" class="mb8"></image-upload-new>
            <el-input v-model="inputForm.valCn" placeholder="请输入跳转项目id" style="width: 200px;"></el-input>
          </div>
          <div class="ta-center mt4">
            <image-upload-new v-model="inputForm.pic" :disabled="settingType" :limit="1" tip="单个图片不要超过10M" class="mb8"></image-upload-new>
            <el-input v-model="inputForm.valCn" placeholder="请输入跳转项目id" style="width: 200px;"></el-input>
          </div>
          <div class="ta-center mt4">
            <image-upload-new v-model="inputForm.pic" :disabled="settingType" :limit="1" tip="单个图片不要超过10M" class="mb8"></image-upload-new>
            <el-input v-model="inputForm.valCn" placeholder="请输入跳转项目id" style="width: 200px;"></el-input>
          </div>
          <div class="ta-center mt4">
            <image-upload-new v-model="inputForm.pic" :disabled="settingType" :limit="1" tip="单个图片不要超过10M" class="mb8"></image-upload-new>
            <el-input v-model="inputForm.valCn" placeholder="请输入跳转项目id" style="width: 200px;"></el-input>
          </div>
          <div class="ta-center mt4">
            <image-upload-new v-model="inputForm.pic" :disabled="settingType" :limit="1" tip="单个图片不要超过10M" class="mb8"></image-upload-new>
            <el-input v-model="inputForm.valCn" placeholder="请输入跳转项目id" style="width: 200px;"></el-input>
          </div> -->
        </div>
      </div>
      <!-- 如何工作 -->
      <div class="howWorks bordersolid mt4 pd16">
        <div class="flex-row jc-center mt8">
          <div class="w100">
            <el-col :span="11">
              <el-input v-model="howWorksTitle.valEn"  :disabled="settingType" class="" @change="changeInput($event,howWorksTitle)"></el-input>
            </el-col>
            <el-col :span="11">
              <el-input v-model="howWorksTitle.valCn"  :disabled="settingType" class="" @change="changeInput($event,howWorksTitle)"></el-input>
            </el-col>
            <el-col :span="2">
              <div class="flex-row ai-end jc-start iconBox">
                <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(howWorksTitle)"></i>
              </div>
            </el-col>
            <el-col :span="11">
              <el-input type="textarea" rows="5" v-model="howWorksContent.valEn"  :disabled="settingType" class="mt8" @change="changeInput($event,howWorksContent)"></el-input>
            </el-col>
            <el-col :span="11">
              <el-input type="textarea" rows="5" v-model="howWorksContent.valCn"  :disabled="settingType" class="mt8" @change="changeInput($event,howWorksContent)"></el-input>
            </el-col>
            <el-col :span="2">
              <div class="flex-row ai-end jc-start iconBox" style="height: 115px;">
                <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(howWorksContent)"></i>
              </div>
            </el-col>
          </div>
        </div>
        <div class="mt8">
          <div class="">步骤条：</div>
          <div class="flex-row flex-w jc-evenly mb8">
            <el-col :span="12" v-for="hitem in howWorksStepList" :key="hitem.id">
              <div class=" mt32"  >
                <div v-for="citem in hitem" :key="citem.id">
                  <image-upload-new  v-if="citem.type == 'image'" v-model="citem.pic" :disabled="settingType" :limit="1" tip="单个图片不要超过10M" class="mb8" @updateChange="changeImage($event,citem)"></image-upload-new>
                  <div  v-else-if="citem.type == 'detail'" class="flex-row mt8">
                    <el-input type="textarea" rows="5" v-model="citem.valEn"  :disabled="settingType" class="" @change="changeInput($event,citem)"></el-input>
                    <el-input type="textarea" rows="5" v-model="citem.valCn"  :disabled="settingType" class="ml8" @change="changeInput($event,citem)"></el-input>
                    <div class="flex-row ai-end jc-center iconBox" style="width:80px;height:115px">
                      <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(citem)"></i>
                    </div>
                  </div>
                  <div  v-else class="flex-row mt8">
                    <el-input v-model="citem.valEn"  :disabled="settingType" class="" @change="changeInput($event,citem)"></el-input>
                    <el-input v-model="citem.valCn"  :disabled="settingType" class="ml8" @change="changeInput($event,citem)"></el-input>
                    <div class="flex-row ai-center jc-center iconBox" style="width:80px;height:40px">
                      <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(citem)"></i>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </div>
        </div>
        
      </div>
      <!-- 我们的服务包括 -->
      <div class="ourService bordersolid mt4 pd4">
        <div class="flex-row jc-center mt8">
          <div class="w100">
            <el-col :span="11">
              <el-input v-model="ourServiceTitle.valEn"  :disabled="settingType" class="" @change="changeInput($event,ourServiceTitle)"></el-input>
            </el-col>
            <el-col :span="11">
              <el-input v-model="ourServiceTitle.valCn"  :disabled="settingType" class="" @change="changeInput($event,ourServiceTitle)"></el-input>
            </el-col>
            <el-col :span="2">
              <div class="flex-row ai-end jc-start iconBox">
                <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(ourServiceTitle)"></i>
              </div>
            </el-col>
            <el-col :span="11">
              <el-input type="textarea" rows="5" v-model="ourServiceContent.valEn"  :disabled="settingType" class="mt8" @change="changeInput($event,ourServiceContent)"></el-input>
            </el-col>
            <el-col :span="11">
              <el-input type="textarea" rows="5" v-model="ourServiceContent.valCn"  :disabled="settingType" class="mt8" @change="changeInput($event,ourServiceContent)"></el-input>
            </el-col>
            <el-col :span="2">
              <div class="flex-row ai-end jc-start iconBox" style="height: 115px;">
                <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(ourServiceContent)"></i>
              </div>
            </el-col>
          </div>
        </div>
        <div class="flex-row flex-w  mb8">
          <el-col :span="12" v-for="oitem in ourfiveServiceList" :key="oitem.id">
            <div class=" mt16"  >
              <div v-for="ocitem in oitem" :key="ocitem.id">
                <image-upload-new v-if="ocitem.type == 'image'" v-model="ocitem.pic" :disabled="settingType" :limit="1" tip="单个图片不要超过10M" class="mb8" @updateChange="changeImage($event,ocitem)"></image-upload-new>
                <div v-else class="flex-row">
                  <el-input v-model="ocitem.valEn"  :disabled="settingType" class="" @change="changeInput($event,ocitem)"></el-input>
                  <el-input v-if="activeName == 'en'" v-model="ocitem.valCn"  :disabled="settingType" class="ml8" @change="changeInput($event,ocitem)"></el-input>
                  <div class="flex-row ai-end jc-center iconBox" style="width:80px;height:40px">
                    <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(ocitem)"></i>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </div>
      </div>
      <div class="slideshowBox bordersolid mt4 pd16">
        <div style="">
          <div>
            <div class="mb8">底图:</div>
            <image-upload-new v-model="slideshowBgImage.pic" :disabled="settingType" :limit="1" tip="单个图片不要超过10M" class="mb8" @updateChange="changeImage($event,slideshowBgImage)"></image-upload-new>
          </div>
          <div class="flex-row flex-w">
            <div class="mb8">左边内容:</div>
            <div class="w100">
              <el-col :span="11">
                <el-input  v-model="slideshowleftTitle.valEn"  :disabled="settingType" class="" @change="changeInput($event,slideshowleftTitle)"></el-input>
              </el-col>
              <el-col :span="11">
                <el-input  v-model="slideshowleftTitle.valCn"  :disabled="settingType" class="" @change="changeInput($event,slideshowleftTitle)"></el-input>
              </el-col>
              <el-col :span="2">
                <div class="flex-row ai-end jc-start iconBox">
                  <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(slideshowleftTitle)"></i>
                </div>
              </el-col>
              <el-col :span="11">
                <el-input type="textarea" rows="5" v-model="slideshowleftContent.valEn"  :disabled="settingType" class="mt8" @change="changeInput($event,slideshowleftContent)"></el-input>
              </el-col>
              <el-col :span="11">
                <el-input type="textarea" rows="5" v-model="slideshowleftContent.valCn"  :disabled="settingType" class="mt8" @change="changeInput($event,slideshowleftContent)"></el-input>
              </el-col>
              <el-col :span="2">
                <div class="flex-row ai-end jc-start iconBox" style="height: 115px;">
                  <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(slideshowleftContent)"></i>
                </div>
              </el-col>
            </div>
          </div>
        </div>
        <div class="flex-row flex-w">
          <div class="mb8 mt8">右边介绍:</div>
          <div class="flex-row flex-w  mb8">
            <el-col :span="12" v-for="(oitem,oindex) in slideshowRightList" :key="oitem.id">
              <div class=" mt16"  >
                <div class="mb8">第{{ oindex + 1 }}个</div>
                <div v-for="soitem in oitem" :key="soitem.id" class=" mt8">
                  <div v-if="soitem.type == 'title'" class="flex-row">
                    <el-input v-model="soitem.valEn"  :disabled="settingType" class="" @change="changeInput($event,soitem)"></el-input>
                    <el-input v-model="soitem.valCn"  :disabled="settingType" class="ml8" @change="changeInput($event,soitem)"></el-input>
                    <div class="flex-row ai-center jc-center iconBox" style="width:80px;height:40px">
                        <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(soitem)"></i>
                      </div>
                  </div>
                  <div v-else class="flex-row">
                    <el-input type="textarea" rows="5" v-model="soitem.valEn"  :disabled="settingType" class="" @change="changeInput($event,soitem)"></el-input>
                    <el-input type="textarea" rows="5" v-model="soitem.valCn"  :disabled="settingType" class="ml8" @change="changeInput($event,soitem)"></el-input>
                    <div class="flex-row ai-end jc-center iconBox" style="width:80px;height:115px">
                      <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(soitem)"></i>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </div>
        </div>
      </div>
      <!-- 订阅 -->
      <div class="subscribeBox bordersolid mt4 mb32 pd4">
        <div class="flex-row jc-center mt8 mb8">
          <div class="w100">
            <el-col :span="11">
              <el-input v-model="subscribeTitle.valEn"  :disabled="settingType" class="" @change="changeInput($event,subscribeTitle)"></el-input>
            </el-col>
            <el-col :span="11">
              <el-input v-model="subscribeTitle.valCn"  :disabled="settingType" class="" @change="changeInput($event,subscribeTitle)"></el-input>
            </el-col>
            <el-col :span="2">
                <div class="flex-row ai-end jc-start iconBox">
                  <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(subscribeTitle)"></i>
                </div>
              </el-col>
            <el-col :span="11">
              <el-input type="textarea" rows="5" v-model="subscribeContent.valEn"  :disabled="settingType" class="mt8" @change="changeInput($event,subscribeContent)"></el-input>
            </el-col>
            <el-col :span="11">
              <el-input type="textarea" rows="5" v-model="subscribeContent.valCn"  :disabled="settingType" class="mt8" @change="changeInput($event,subscribeContent)"></el-input>
            </el-col>
            <el-col :span="2">
                <div class="flex-row ai-end jc-start iconBox" style="height: 115px;">
                  <i class="el-icon-s-tools" style="font-size: 20px;" @click="handFont(subscribeContent)"></i>
                </div>
              </el-col>
          </div>
        </div>
      </div>
    </el-row>
    </div>
    <fontSizeFamilyForm  ref="fontSizeFamilyFormRef"></fontSizeFamilyForm>
  </div>
</template>
<script>
import ImageUploadNew from '@/components/upload/ImageUploadNoAddIon'
import CropperView from '@/components/upload/ImageUploadCropper.vue'
import companyMessageService from '@/api/companymessage/companyMessageService'
import fontSizeFamilyForm from './fontSizeFamilyForm'
import llFilter from '@/utils/listLayoutFilter.js'
export default {
  data () {
    return {
      inputForm: {
        pic: '',
        valEn: '',
        valCn: ''
      },
      settingType: true,
      activeName: 'en',
      dataList: [],
      aboutUsTitle: {},
      aboutUsContent: {},
      aboutUsList: [],
      aboutUsBasicsList: [],
      firstScreenImage: {},
      firstScreenTitle: {},
      firstScreenContent: {},
      ourProjectTitle: {},
      howWorksTitle: {},
      howWorksContent: {},
      howWorksStepList: [],
      ourServiceTitle: {},
      ourServiceContent: {},
      ourfiveServiceList: [],
      slideshowBgImage: {},
      slideshowleftTitle: {},
      slideshowleftContent: {},
      slideshowRightList: [],
      subscribeTitle: {},
      subscribeContent: {},
      uploadVideoSize: 10
    }
  },
  components: {
    ImageUploadNew,
    CropperView,
    fontSizeFamilyForm
  },
  activated () {
    this.refreshList()
    let uploadSize = localStorage.getItem('uploadVideoSize')
    this.uploadVideoSize = Number(uploadSize)
  },
  methods: {
    handFont (e) {
      if (this.settingType === false) {
        this.$refs.fontSizeFamilyFormRef.init('edit', e.id)
      }
    },
    handSetting () {
      this.settingType = !this.settingType
    },
    // 获取数据列表
    refreshList () {
      this.dataList = []
      this.aboutUsList = []
      this.aboutUsBasicsList = []
      this.howWorksStepList = []
      this.ourfiveServiceList = []
      this.slideshowRightList = []
      companyMessageService.list({
        'current': '1',
        'size': '1000',
        'orders': {column: 'create_data', asc: false}
      }).then(({data}) => {
        this.dataList = data.records
        this.firstScreenImage = llFilter.findData(data.records, 'firstScreen-image')
        this.firstScreenTitle = llFilter.findData(data.records, 'firstScreen-title')
        this.firstScreenContent = llFilter.findData(data.records, 'firstScreen-content')
        this.aboutUsTitle = llFilter.findData(data.records, 'home-aboutUs-title')
        this.aboutUsContent = llFilter.findData(data.records, 'home-aboutus-content')
        this.aboutUsList.push(llFilter.findData(data.records, 'home-aboutUs-experience'))
        this.aboutUsList.push(llFilter.findData(data.records, 'home-aboutUs-cornerstones'))
        this.aboutUsList.push(llFilter.findData(data.records, 'home-aboutUs-projects'))
        this.aboutUsBasicsList.push(llFilter.filterData(data.records, 'aboutUs-basics-team', ['Image', 'Title', 'Tip']))
        this.aboutUsBasicsList.push(llFilter.filterData(data.records, 'aboutUs-basics-sys', ['Image', 'Title', 'Tip']))
        this.aboutUsBasicsList.push(llFilter.filterData(data.records, 'aboutUs-basics-sc', ['Image', 'Title', 'Tip']))
        this.aboutUsBasicsList.push(llFilter.filterData(data.records, 'aboutUs-basics-design', ['Image', 'Title', 'Tip']))
        this.ourProjectTitle = llFilter.findData(data.records, 'ourProjectTitle')
        this.howWorksTitle = llFilter.findData(data.records, 'home-howWorks-title')
        this.howWorksContent = llFilter.findData(data.records, 'home-howWorks-content')
        this.howWorksStepList.push(llFilter.filterData(data.records, 'howWork-setp1', ['image', 'title', 'tip', 'detail']))
        this.howWorksStepList.push(llFilter.filterData(data.records, 'howWork-setp2', ['image', 'title', 'tip', 'detail']))
        this.howWorksStepList.push(llFilter.filterData(data.records, 'howWork-setp3', ['image', 'title', 'tip', 'detail']))
        this.howWorksStepList.push(llFilter.filterData(data.records, 'howWork-setp4', ['image', 'title', 'tip', 'detail']))
        this.howWorksStepList.push(llFilter.filterData(data.records, 'howWork-setp5', ['image', 'title', 'tip', 'detail']))
        this.howWorksStepList.push(llFilter.filterData(data.records, 'howWork-setp6', ['image', 'title', 'tip', 'detail']))
        this.ourServiceTitle = llFilter.findData(data.records, 'home-server-title')
        this.ourServiceContent = llFilter.findData(data.records, 'home-server-content')
        this.ourfiveServiceList.push(llFilter.filterData(data.records, 'home-fiveServer1', ['image', 'title']))
        this.ourfiveServiceList.push(llFilter.filterData(data.records, 'home-fiveServer2', ['image', 'title']))
        this.ourfiveServiceList.push(llFilter.filterData(data.records, 'home-fiveServer3', ['image', 'title']))
        this.ourfiveServiceList.push(llFilter.filterData(data.records, 'home-fiveServer4', ['image', 'title']))
        this.ourfiveServiceList.push(llFilter.filterData(data.records, 'home-fiveServer5', ['image', 'title']))
        this.slideshowBgImage = llFilter.findData(data.records, 'slideshow-bg-image')
        this.slideshowleftContent = llFilter.findData(data.records, 'slideshow-left-content')
        this.slideshowleftTitle = llFilter.findData(data.records, 'slideshow-left-title')
        this.slideshowRightList.push(llFilter.filterData(data.records, 'slideshow-right-introduce1', ['title', 'content']))
        this.slideshowRightList.push(llFilter.filterData(data.records, 'slideshow-right-introduce2', ['title', 'content']))
        this.slideshowRightList.push(llFilter.filterData(data.records, 'slideshow-right-introduce3', ['title', 'content']))
        this.slideshowRightList.push(llFilter.filterData(data.records, 'slideshow-right-introduce4', ['title', 'content']))
        this.slideshowRightList.push(llFilter.filterData(data.records, 'slideshow-right-introduce5', ['title', 'content']))
        this.slideshowRightList.push(llFilter.filterData(data.records, 'slideshow-right-introduce6', ['title', 'content']))
        this.slideshowRightList.push(llFilter.filterData(data.records, 'slideshow-right-introduce7', ['title', 'content']))
        this.subscribeTitle = llFilter.findData(data.records, 'home-subscribe-title')
        this.subscribeContent = llFilter.findData(data.records, 'home-subscribe-content')
      })
    },
    //  upload image 上传图片
    changeImage (e, item) {
      if (e) {
        item.pic = typeof e === 'string' ? e : e.filePath
        this.saveData(item)
      } else {
        item.pic = ''
        this.saveData(item)
      }
    },
    // input修改事件
    changeInput (e, item) {
      if (e) {
        this.saveData(item)
      }
    },
    // 更新数据
    saveData (inputForm) {
      companyMessageService.save(inputForm).then(({data}) => {
        this.$message.success('设置成功')
        // this.refreshList()
      }).catch(() => {
        this.$message.error('设置失败')
      })
    }
  }
}
</script>
<style scoped lang="less">
.main {
  padding: 10px;
  height: 100%;
  background-color: #fff;
  overflow-y: auto;
  .homeLayout {
    .layout_bg {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      padding-top: 20px;
    }
    .layout_aboutUs{
    }
  }
}
.inputWidth{
  width: 300px !important;
}
.el-input{
  display: block;
}
.bordersolid{
  border: 1px solid rgba(112, 110, 110, 0.596);
}
.ta-center{
  text-align: center;
}
::v-deep .el-tabs__item{
  padding: 0 20px !important;
}
.w100 {
  width: 100%;
}
.fw-warp{
  flex-wrap: wrap;
}
.ml8{
  margin-left: 8px;
}
.mt8 {
  margin-top: 8px;
}
.iconBox {
  width: 80px;
  height: 40px;
  cursor: pointer;
}
</style>
